import { useParams } from "react-router-dom";
import { blogData } from "./blog-data";

const SingleBlog = () => {
	const { id } = useParams();
	const blog = blogData.find((item) => item.id === id);
	return (
		<section>
			<div className='bg-[#F5F7FF]'>
				<div className='max-w-[1000px] lg:w-full w-[90%] mx-auto md:pt-[170px] pt-48 pb-[55px] text-center space-y-4 font-dm-sans'>
					<p className=' text-base/6 font-semibold'>
						Published:{" "}
						<span className='text-lg/8 text-[#004594]'>{blog?.post_date}</span>
					</p>
					<h1 className='text-[#101828] text-5xl/[60px]  font-semibold mb-4'>
						{blog?.title}
					</h1>
					<p className='text-[#667085] text-xl/[30px] mb-6'>{blog?.summary}</p>
					<ul className='flex justify-center items-center flex-wrap gap-2 mb-10'>
						{blog?.tags?.map((tag, index) => {
							// Define an array of colors
							const colors = [
								"#4321CB",
								"#C16B02",
								"#0B8948",
								"#870000",
								"#363F72",
							];
							// Select a color based on the index
							const color = colors[index % colors.length];

							return (
								<li
									key={index}
									className={`py-1 px-2.5 rounded-2xl text-[${color}] bg-[${color}]/20`}>
									{tag}
								</li>
							);
						})}
					</ul>
					<div className='max-h-[460px] w-full overflow-hidden rounded-3xl '>
						<img
							src={blog?.imageSrc || ""}
							alt=''
							className='w-full max-h-[460px] rounded-3xl hover:scale-105 object-cover duration-600'
						/>
					</div>
				</div>
			</div>

			<div className='bg-white'>
				<div className='max-w-[1440px] w-[90%] mx-auto flex  justify-between lg:py-20 py-14'>
					<div className='lg:max-w-[800px] mx-auto w-full space-y-6'>
						<h4 className='text-[30px] leading-10 font-bold text-[#101828]'>
							Introduction
						</h4>
						{blog?.introduction ? (
							<p
								className=''
								dangerouslySetInnerHTML={{ __html: blog.introduction }}
							/>
						) : (
							<p className=''>Introduction not available.</p>
						)}

						{blog?.content?.map((content, index) => (
							<div key={index} className='space-y-4'>
								<h4 className='text-[30px] leading-10 font-bold text-[#101828] text-center'>
									{content.subheader}
								</h4>
								<p
									className=''
									dangerouslySetInnerHTML={{ __html: content.paragraph }}
								/>
							</div>
						))}
					</div>
					<div className='xl:flex hidden'></div>
				</div>
			</div>
		</section>
	);
};
export default SingleBlog;
